/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { SectionGrid } from "frontend/src/components/Layout"
import { CMSLink } from "frontend/src/components/CMSLink"
import { BlockText } from "frontend/src/components/BlockText"

function SubscriptionConfirmation({ confirmatiomMessage }) {
  const [heading, ...body] = confirmatiomMessage
  const button = { internalRef: { slug: { current: "home" } } }
  return (
    <SectionGrid sx={{ pt: [10, 10, 11, 11, 17], pb: [7, 7, 8, 8, 12] }}>
      <SectionGrid.narrow>
        <div
          sx={{
            width: ["90%", "90%", "100%"],
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            mx: ["auto", "auto", "unset"],
          }}
        >
          <div
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              px: 5,
              py: [5, 5, 5, 5, 8],
            }}
          >
            <div sx={{ mt: 0, mb: 8 }}>
              <BlockText
                style={{
                  textAlign: "center",
                  fontFamily: "heading",
                  fontSize: ["28px", "28px", "38px"],
                  lineHeight: ["30px", "30px", "44px"],
                  fontWeight: ["medium", "medium", "regular"],
                  my: 0,
                  letterSpacing: "-1.24px",
                }}
                blocks={heading}
                as={"h1"}
              />
            </div>
            <div sx={{ mb: [11, 11, 11, 11, 17] }}>
              <BlockText
                blocks={body}
                as="p"
                style={{
                  fontFamily: "body",
                  fontSize: ["18px", "18px", "22px"],
                  lineHeight: ["26px", "26px", "28px"],
                  fontWeight: "light",
                  letterSpacing: "0.24px",
                  textAlign: "center",
                  my: 0,
                }}
              />
            </div>
            <div
              sx={{
                width: ["90%", "90%", "100%"],
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div sx={{ textAlign: "center", width: "100%" }}>
                <CMSLink
                  sx={{
                    py: 5,
                    px: 7,
                    textAlign: "center",
                    bg: "almostBlack",
                    color: "white",
                    fontFamily: "heading",
                    textTransform: "uppercase",
                    fontSize: "16px",
                    lineHeight: "16px",
                    fontWeight: "light",
                  }}
                  link={button}
                >
                  Zurück zur Startseite
                </CMSLink>
              </div>
            </div>
          </div>
        </div>
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { SubscriptionConfirmation }
